// Generated by ReScript, PLEASE EDIT WITH CARE


function getDefaultErrorEntity(message, titleOpt, param) {
  var title = titleOpt !== undefined ? titleOpt : ({
        TAG: /* UnprocessedEntity */1,
        _0: undefined
      });
  return /* DefaultError */{
          _0: {
            title: title,
            message: message
          }
        };
}

function getErrorEntity(error) {
  return error._0.title;
}

function resolveError(error) {
  return error._0.message;
}

export {
  getDefaultErrorEntity ,
  getErrorEntity ,
  resolveError ,
}
/* No side effect */
